import styled from 'styled-components';

interface PietroskiFormItemProps {
    width?: string;
    minHeight?: string;
    margin?: string;
    labelFrontSize?: string;
    labelAlign?: string;
}

export const PietroskiFormItem = styled.div`
    width: ${(props: PietroskiFormItemProps) => props.width ? `${props.width}` : "90%"};
    min-height: ${(props: PietroskiFormItemProps) => props.minHeight ? `${props.minHeight}` : "70px"};
    margin : ${(props: PietroskiFormItemProps) => props.margin ? `${props.margin}` : "5px auto"};
    font-size: ${(props: PietroskiFormItemProps) => props.labelFrontSize ? `${props.labelFrontSize}` : "1.25rem"};
    text-align: center;
    
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;

    span {
        margin-bottom: 5px;
        align-self: ${(props: PietroskiFormItemProps) => props.labelAlign ? `${props.labelAlign}` : "flex-start"};
    }

    .error {
        margin-top: 5px;
        font-size: ${(props: PietroskiFormItemProps) => props.labelFrontSize ? `calc(${props.labelFrontSize}/1.2)` : "1rem"};
        color: #ff4343;
    }
`;